import clsx from 'clsx'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Ban, CircleCheck, CircleHelp, CircleMinus } from 'lucide-react'
import React from 'react'
import { useStyles } from './styles'

type AppUserStatusIconProps = {
    className?: string
    iconSize?: 'small' | 'inherit' | 'medium' | 'large'
}

const mapIconSize = (iconSize?: 'small' | 'inherit' | 'medium' | 'large'): 'sm' | 'md' | 'lg' | undefined => {
    switch (iconSize) {
        case 'small':
            return 'sm'
        case 'medium':
        case 'inherit':
            return 'md'
        case 'large':
            return 'lg'
        default:
            return undefined
    }
}

export const AppUserStatusIconEnabled = ({ className, iconSize }: AppUserStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return <C1Icon icon={CircleCheck} size={mapIconSize(iconSize)} aria-label="enabled" className={clsx(className, classes.enabled)} />
}

export const AppUserStatusIconDisabled = ({ className, iconSize }: AppUserStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return (
        <C1Icon icon={CircleMinus} size={mapIconSize(iconSize)} aria-label="disabled" className={clsx(className, classes.disabled)} />
    )
}

export const AppUserStatusIconDeleted = ({ className, iconSize }: AppUserStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return <C1Icon icon={Ban} size={mapIconSize(iconSize)} aria-label="deleted" className={clsx(className, classes.deleted)} />
}

export const AppUserStatusIconUnknown = ({ className, iconSize }: AppUserStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return <C1Icon icon={CircleHelp} size={mapIconSize(iconSize)} aria-label="unknown" className={clsx(className, classes.unknown)} />
}
